import { NextResponse } from "next/server"
import { wooCommerceApi } from "@/services/api"

// Debug endpoint to inspect raw WordPress review data
// Usage: GET /api/debug/review/[reviewId]
export async function GET(
  request: Request,
  { params }: { params: Promise<{ id: string }> }
) {
  const { id } = await params

  try {
    const response = await wooCommerceApi.get(`/products/reviews/${id}`)

    return NextResponse.json(
      {
        ok: true,
        review: response.data,
        meta_data: response.data.meta_data || null,
        all_keys: Object.keys(response.data),
      },
      {
        headers: {
          "Cache-Control": "no-store",
        },
      }
    )
  } catch (error) {
    return NextResponse.json(
      {
        ok: false,
        error: error instanceof Error ? error.message : "Unknown error",
      },
      {
        status: 500,
        headers: {
          "Cache-Control": "no-store",
        },
      }
    )
  }
}
